import React from "react";

const RecentUsersList = ({ users = [] }) => {
  if (!users || users.length === 0) {
    return <div className="ru-empty">No recent users.</div>;
  }

  return (
    <div className="ru-scroll">
      <ul className="ru-list">
        {users.map((u) => {
          const joined = new Date(u.createdAt).toLocaleDateString();
          const initials = (u.name || u.email || "?")
            .trim()
            .split(/\s+/)
            .map((s) => s[0])
            .slice(0, 2)
            .join("")
            .toUpperCase();

          const roleClass = u.role === "admin" ? "role--admin" : "role--default";

          return (
            <li key={u._id} className="ru-item">
              {/* Left: avatar + identity */}
              <div className="ru-left">
                <div className="ru-avatar" aria-hidden="true">{initials}</div>
                <div className="ru-name-email">
                  <div className="ru-name" title={u.name}>{u.name}</div>
                  <a className="ru-email" href={`mailto:${u.email}`} title={u.email}>
                    {u.email}
                  </a>
                </div>
              </div>

              {/* Middle: role chip */}
              <div className="ru-middle">
                <span className={`ru-role ${roleClass}`} title={`Role: ${u.role}`}>
                  {u.role}
                </span>
              </div>

              {/* Right: joined date */}
              <div className="ru-right">
                <span className="ru-joined" title={joined}>{joined}</span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default RecentUsersList;
